import { lazy } from "react";
import { ALLOWED_MODULES } from "../../constants/enums";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { RSA_PACKAGES_ROUTE } from "./rsaPackages.constant";

// Lazy imports
const RsaPackageList = Loadable(
  lazy(() =>
    import("./RsaPackageList").then(({ RsaPackageList }) => ({
      default: RsaPackageList,
    }))
  )
);

const ManageRsaPackage = Loadable(
  lazy(() =>
    import("./ManageRsaPackage").then(({ ManageRsaPackage }) => ({
      default: ManageRsaPackage,
    }))
  )
);

export const rsaPackageRoutes = [
  {
    path: RSA_PACKAGES_ROUTE,
    element: (
      <AuthorizedRoute
        moduleIds={[ALLOWED_MODULES.RSA_PACKAGES]}
      >
        <RsaPackageList />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${RSA_PACKAGES_ROUTE}/manage`,
    element: (
      <AuthorizedRoute
        moduleIds={[ALLOWED_MODULES.RSA_PACKAGES]}
      >
        <ManageRsaPackage />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${RSA_PACKAGES_ROUTE}/manage/:uuid`,
    element: (
      <AuthorizedRoute
        moduleIds={[ALLOWED_MODULES.RSA_PACKAGES]}
      >
        <ManageRsaPackage />
      </AuthorizedRoute>
    ),
  },
];
